

const formBackgroundImgLayoutOptions = [
  {
    label: '全覆盖',
    value: 'all'
  },
  {
    label: '高度自适应',
    value: 'autoHeight'
  }
]
export const config = {
  propsName: 'renderProps',
  name: 'formUniversalConfig',
  type: 'homeConfig',
  icon: 'el-icon-setting',
  cnName: '表单通用配置',
  tooltip: '表单通用配置',  
  props: [
    {
      // tooltip:'背景图的tooltip',
      type: () => import('@/weappTmps/comps/backgroundColor/index.vue'),
      cmpPath: '/comps/backgroundColor/index.vue',
      key: 'formBackgroundColor',
      bind: {
        label: '表单背景色',
        quoteKey:'backgroundColor'
      },
      on: {},
      value: null
    },
    
    {
      // tooltip:'背景图的tooltip',
      type: 'sp-backgroundImg',
      key: 'formBackgroundImg',
      bind: {
        label: '表单背景图',
        'layout-options':formBackgroundImgLayoutOptions,
        'layout-type':2,
        quoteKey:'backgroundImg'
      },
      on: {},
      value: {}
    },            
   
    {
      type: () => import('@/weappTmps/comps/margin/index.vue'),
      cmpPath: '/comps/margin/index.vue',
      key: 'margin',
      bind: {
        label: '表单外边距'
      },
      on: {},
      value: null
    },
    {
      type: () => import('@/weappTmps/comps/margin/index.vue'),
      cmpPath: '/comps/margin/index.vue',
      key: 'padding',
      bind: {
        label: '表单内边距',
        type:'padding'
      },
      on: {},
      value: [0,0,0,0]
    },
    {
      type: 'el-input',
      key: 'buttonTitle',
      bind: {
        label: '表单按钮文案',
        placeholder: '请输入提示内容'
      },
      value: '表单按钮'
    },
    {
      // tooltip:'背景图的tooltip',
      type: () => import('@/weappTmps/comps/color/index.vue'),
      cmpPath: '/comps/color/index.vue',
      key: 'buttonColor',
      bind: {
        label: '按钮字体颜色',
        quoteKey:'color'
      },
      on: {},
      value: null
    },
    {
      // tooltip:'背景图的tooltip',
      type: () => import('@/weappTmps/comps/backgroundColor/index.vue'),
      cmpPath: '/comps/backgroundColor/index.vue',
      key: 'buttonBackgroundColor',
      bind: {
        label: '按钮背景色',
        quoteKey:'backgroundColor'
      },
      on: {},
      value: null
    },
    {
      type: () => import('@/weappTmps/comps/borderRadius/index.vue'),
      cmpPath: '/comps/borderRadius/index.vue',
      key: 'borderRadius',
      bind: {
        label: '圆角度数（px）'
      },
      on: {},
      value: null
    }
  ]
}
